export const TEST_ID = 'prescriptionStatusRow';

export const ZONE_COUNT_TEST_ID = 'prescriptionStatusRowZoneCount';

export const DETACH_BUTTON_TEST_ID = 'prescriptionStatusRowDetachButton';
